import { COPY } from "../../content/copy";

export const caseImages = (item) => [
    ...(item.metrics?.shots || []).map((shot) => ({
        src: shot.full, alt: shot.alt, title: shot.alt,
        collection: "Casi senza nome", description: item.metrics.source,
    })),
    ...(item.photo ? [{ ...item.photo, title: item.photo.label, collection: "Casi senza nome", description: item.title }] : []),
];

export const BOTTEGA_IMAGES = [
    { src: COPY.bottega.images.desktop, alt: "Lo store Bottega Paesano su desktop", title: "Lo store, su desktop" },
    { src: COPY.bottega.images.mobile, alt: "Lo store Bottega Paesano su telefono", title: "Lo store, su mobile" },
    { ...COPY.bottega.backstage, title: COPY.bottega.backstage.caption },
    ...COPY.bottega.app.screens.map((screen) => ({ ...screen, alt: screen.label, title: screen.label })),
].map((image) => ({ ...image, collection: "Bottega Paesano" }));

export const SERVICE_IMAGES = COPY.servizi.items.filter((item) => item.image).map((item) => ({
    ...item.image, title: item.title, description: item.image.alt, collection: "Il nostro lavoro",
}));